export enum PubNubMessageKey {
  StudentResponse = 'studentResponse',
  StudentNameSet = 'studentNameSet',
  StudentFinished = 'studentFinished',
  LongMessage = 'longMessageId',
  ActivityChange = 'localActivity',
}

export type StudentResponsePubnubData = {
  is_correct: boolean;
  hidden: boolean;
  student_name: string;
  selection_answers: Array<{ answer_id: number }>;
  question: number;
  activity_instance: number; // Only on the live events! Not on the API.
  team: number;
  user_uuid: string;
  id: number;
  text_answers: Array<{ answer_text: string }>;
};

export type StudentResponsePubNubMessage = {
  key: PubNubMessageKey.StudentResponse;
  data: StudentResponsePubnubData;
};

export type StudentNameSet = {
  key: PubNubMessageKey.StudentNameSet;
  data: {
    student_name: string;
    user_uuid: string;
    user_previous_uuid?: string;
  };
};

export type StudentFinishedChange = {
  key: PubNubMessageKey.StudentFinished;
  data: {
    student_finished: boolean;
    user_uuid: string;
  };
};

export type LongMessage = {
  key: PubNubMessageKey.LongMessage;
  data: {
    longMessageId: number;
  };
};

export type ActivityChange = {
  key: PubNubMessageKey.ActivityChange;
  data: 'activity_paused' | 'activity_resumed' | 'activity_ended';
};

export type PubnubMessage =
  | StudentResponsePubNubMessage
  | StudentNameSet
  | StudentFinishedChange
  | LongMessage
  | ActivityChange;
